module.exports = __webpack_public_path__ + "static/drumster-extraimg2@2x-min-1faa5d9ef2c61944b84ea516de75d657.png";